import Appointments from './appointments';
import Availability from './availability';
import Connections from './connections';
import GeneralInfo from './general-info';
import Groups from './groups';
import Services from './services';
import CAQHAccess from '../../provider/profile-v2/caqh-access';
import MDToolboxAccess from '../../provider/profile-v2/mdtoolbox-access';
import CAQHInformation from '../../provider/profile-v2/caqh-information';
import BoardCertifications from '../../provider/profile-v2/board-certifications';
import Licenses from '../../provider/profile-v2/licences';
import DEACDSNumbers from '../../provider/profile-v2/dea-cds-number';
import Degrees from '../../provider/profile-v2/degrees';
import MalpracticeCoverage from '../../provider/profile-v2/malpractice';

const SelectedComponent = ({ selectedScreen, navItemStatus, setNavItemStatus, userId, refresh }) => {
  switch (selectedScreen) {
    case 'generalInformation':
      return <GeneralInfo />;
    case 'connections':
      return <Connections />;
    case 'appointments-current':
    case 'appointments-past':
    case 'appointments-pending':
      return <Appointments />;
    case 'availability':
      return <Availability />;
    case 'groups':
      return <Groups />;
    case 'services':
      return <Services />;
    case 'CAQHAccess':
      return (
        <CAQHAccess
          navItemStatus={navItemStatus}
          setNavItemStatus={setNavItemStatus}
          refresh={refresh}
          userId={userId}
        />
      );
    case 'MDToolboxAccess':
      return (
        <MDToolboxAccess
          navItemStatus={navItemStatus}
          setNavItemStatus={setNavItemStatus}
          refresh={refresh}
          userId={userId}
        />
      );
    case 'CAQHInformation':
      return <CAQHInformation userId={userId} />;
    case 'boardCertifications':
      return <BoardCertifications refresh={refresh} userId={userId} />;
    case 'licenses':
      return <Licenses refresh={refresh} userId={userId} />;
    case 'DEACDSNumbers':
      return <DEACDSNumbers refresh={refresh} userId={userId} />;
    case 'degrees':
      return <Degrees refresh={refresh} userId={userId} />;
    case 'malpracticeCoverage':
      return <MalpracticeCoverage refresh={refresh} userId={userId} />;
    default:
      return <div>In Progress...</div>;
  }
};

export default SelectedComponent;
